import React, { useRef, useState, useCallback } from "react";
import Select, { components } from "react-select";
import { vendorDropdownStyle } from "../../../assets/scss/style";
import Button from "../Buttons/Button";
import { AddIcon } from "../../../assets/icons/iconsProvider";
import { buttonTypeConstants, EMPTY_STRING } from "../../../constants";

const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>
    <div className="d-flex align-items-center gap-4">{children}</div>
  </components.SingleValue>
);

const ComboBoxField = ({
  label,
  options,
  isDisabled,
  handleChange,
  selectedValue,
  isClearable = false,
  handleAddClick,
  buttonLabel = "Add",
  placeHolder = "Select...",
  fieldName,
}) => {
  const selectRef = useRef(null);
  const [inputValue, setInputValue] = useState(EMPTY_STRING);

  const noOptionFound = useCallback(() => {
    if (!inputValue) return <span>No Data Found</span>;

    return (
      <div className="d-flex flex-column justify-content-center align-items-center gap-2 px-2 py-1">
        <span>No match found</span>
        <Button
          label={`${buttonLabel} "${inputValue}"`}
          buttonType={buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE}
          IconImage={AddIcon}
          handleClick={() => {
            handleAddClick(inputValue, fieldName);
            setInputValue(EMPTY_STRING);
          }}
          className="add-customer-button-select w-100"
        />
      </div>
    );
  }, [inputValue, buttonLabel, fieldName, handleAddClick]);

  const handleKeyDown = useCallback(
    (event) => {
      if (
        event.key === "Enter" &&
        inputValue &&
        !options.some(
          (opt) => opt.label.toLowerCase() === inputValue.toLowerCase()
        )
      ) {
        handleAddClick(inputValue, fieldName);
        setInputValue(EMPTY_STRING);
        event.preventDefault();
      }
    },
    [inputValue, options, handleAddClick, fieldName]
  );

  return (
    <div className="combo-box-field">
      {label && <label className="field-label">{label}</label>}
      <Select
        ref={selectRef}
        options={options}
        getOptionLabel={(e) => e.label}
        getOptionValue={(e) => e.value}
        components={{ IndicatorSeparator: () => null, SingleValue }}
        styles={vendorDropdownStyle}
        onChange={handleChange}
        noOptionsMessage={noOptionFound}
        placeholder={placeHolder}
        value={selectedValue}
        isDisabled={isDisabled}
        inputValue={inputValue}
        isClearable={isClearable}
        onInputChange={(value, actionMeta) => {
          if (actionMeta.action !== "set-value") {
            setInputValue(value);
          }
        }}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default React.memo(ComboBoxField);
